import * as React from 'react';
export const IcOperatingTable = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.78 8.71c.19.19.44.29.71.29.27 0 .52-.11.71-.29.82-.83 1.01-2.05.57-3.05l.95-.95a.996.996 0 10-1.41-1.41l-.94.94a2.76 2.76 0 00-3.06.57.996.996 0 000 1.41l2.49 2.49h-.02zM19 11H8.07L6.66 8.89a1.987 1.987 0 00-2.77-.55c-.92.61-1.17 1.85-.55 2.77l1.41 2.11A3.979 3.979 0 008.08 15h2.93v4h-2c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-2v-4h6c1.1 0 2-.9 2-2s-.9-2-2-2H19z'
      fill='currentColor'
    />
  </svg>
);
